import Axios from "axios";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { LeadNotes } from "../../pages/SharedPages/LeadsPage/LeadNotes";
import type { HandleLeadNoteSubmitProps } from "../../pages/SharedPages/LeadsPage/LeadNotes";
import type { LeadNote } from "../../types/types";
import { useStoreState } from "../../util/util";
import { Notifications } from "../Notifications/NotificationsContext";

export type TransactionNotesType = "sample" | "quote" | "order";

export function TransactionNotes({
  transactionType,
  transactionId,
  notes,
  mutate,
}: {
  transactionType: TransactionNotesType;
  transactionId: string;
  notes?: LeadNote[];
  mutate: () => void;
}) {
  const { t } = useTranslation();
  const { storefront_id } = useStoreState();
  const { notifyError, notifySuccess } = useContext(Notifications);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async ({
    note,
    onSuccess,
  }: HandleLeadNoteSubmitProps) => {
    try {
      setIsSaving(true);
      await Axios.post(
        `/v1/storefronts/${storefront_id}/${transactionType}/${transactionId}/notes`,
        { message: note, type: transactionType }
      );
      onSuccess();
      mutate();
      notifySuccess(t("Note added successfully"));
    } catch (error) {
      notifyError(t("There was an error adding the note"), { error });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <LeadNotes
      internal_notes={notes ?? []}
      isSaving={isSaving}
      handleSubmit={handleSubmit}
    />
  );
}
